import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function Hero() {
  return <section className="relative min-h-screen w-full bg-dark-bg overflow-hidden" data-id="element-135">
      {/* Blueprint grid overlay */}
      <div className="absolute inset-0 blueprint-grid" data-id="element-136" />

      {/* Noise texture */}
      <div className="absolute inset-0 noise-overlay" data-id="element-137" />

      {/* Radial gradient fade */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-dark-bg" data-id="element-138" />

      <motion.div className="relative z-10 max-w-4xl mx-auto px-6 py-20 md:py-32 flex flex-col items-center text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-139">
        {/* Eyebrow */}
        <motion.div variants={itemVariants} className="mb-6" data-id="element-140">
          <span className="inline-block px-4 py-2 text-xs md:text-sm font-inter font-semibold tracking-[0.3em] text-orange-accent uppercase border border-orange-accent/30 bg-orange-accent/5" data-id="element-141">
            CLASSIFIED // LEVEL 2 CLEARANCE
          </span>
        </motion.div>

        {/* Main Headline */}
        <motion.h1 variants={itemVariants} className="font-bebas text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-wide text-white mb-6" data-id="element-142">
          WHY A $3,000 LIBERTY SAFE IS THE BIGGEST{' '}
          <span className="text-orange-accent" data-id="element-143">"STEAL ME"</span> SIGN IN YOUR
          HOUSE
        </motion.h1>

        {/* Subheadline */}
        <motion.p variants={itemVariants} className="font-inter text-lg md:text-xl text-concrete max-w-2xl mb-10 leading-relaxed" data-id="element-144">
          The{' '}
          <span className="text-white font-semibold" data-id="element-145">
            Invisible Anchor Method
          </span>
          : Build a Fireproof, Hidden Vault for{' '}
          <span className="text-orange-accent font-bold" data-id="element-146">$500</span> — No Paper
          Trail, No Delivery Truck, No Target on Your Back.
        </motion.p>

        {/* Product Image */}
        <motion.div variants={itemVariants} className="mb-10 w-full max-w-md" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/m9FhLpYcYjfj2UC1nUsn2G/heylloyd-image-1771478685936.png" alt="The Concrete Bunker Blueprint - Digital Guide on Tablet" className="w-full h-auto drop-shadow-2xl" data-id="element-148" />
        </motion.div>

        {/* CTA Button */}
        <motion.div variants={itemVariants} data-id="element-149">
          <motion.button onClick={() => document.getElementById('checkout')?.scrollIntoView({
          behavior: 'smooth'
        })} className="group inline-flex items-center gap-3 px-8 py-4 bg-orange-accent text-white font-inter font-bold text-lg uppercase tracking-wide rounded-sm transition-all duration-300 hover:bg-orange-accent/90 hover:scale-[1.02] active:scale-[0.98] whitespace-nowrap" whileHover={{
          boxShadow: '0 0 30px rgba(224, 123, 57, 0.4)'
        }} data-id="element-150">
            <span data-id="element-151">GET INSTANT ACCESS $6.36</span>
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-152" />
          </motion.button>
        </motion.div>

        {/* Trust Line */}
        <motion.p variants={itemVariants} className="mt-6 flex items-center gap-2 text-sm text-concrete/80 font-inter" data-id="element-153">
          <LockIcon className="w-4 h-4 text-orange-accent" data-id="element-154" />
          Instant Digital Download · No Physical Delivery · No Paper Trail
        </motion.p>
      </motion.div>
    </section>;
}